import { render, staticRenderFns } from "./clear.vue?vue&type=template&id=64e9e4ff&scoped=true&"
import script from "./clear.vue?vue&type=script&lang=js&"
export * from "./clear.vue?vue&type=script&lang=js&"
import style0 from "./clear.vue?vue&type=style&index=0&id=64e9e4ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e9e4ff",
  null
  
)

export default component.exports